import { render, staticRenderFns } from "./exchange2.vue?vue&type=template&id=4a6b3766&scoped=true&"
import script from "./exchange2.vue?vue&type=script&lang=js&"
export * from "./exchange2.vue?vue&type=script&lang=js&"
import style0 from "./exchange2.vue?vue&type=style&index=0&id=4a6b3766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b3766",
  null
  
)

export default component.exports